import { LanguageSelector } from 'components/language-selector/language-selector';
import { OVERSIZED_CLASS } from 'components/oversized-widget/oversized.store';
import { headerStore } from 'global/header.store';
import { layoutStore } from 'global/layout.store';
import { h } from 'preact';
import { useEffect } from 'preact/hooks';

export const InitialPageLst = () => {
  useEffect(() => {
    headerStore.backState.next('');
    headerStore.title.next('Live Site Translator');
    layoutStore.scrollTop(0, false);
    layoutStore.mainContainer.removeClass(OVERSIZED_CLASS);
  }, []);

  return (
    <div className="uwaw-initial-page">
      <ul className="uwaw-options">
        <li className="uwaw-options__item lst">
          <LanguageSelector />
        </li>
      </ul>
    </div>
  );
};
